import installationInstructions from './installationInstructions';

const smartScaleCategoryContent = {
  installationInstructions
}

export { smartScaleCategoryContent };
